export default "__VITE_ASSET__0n5l361f__"